<template>
  <div class="absolute fill-height events-page">

    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>

      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title class="pt-0 pl-0">
            <h2 v-if="!editMode">Nová sleva</h2>
            <h2 v-else>Upravit slevu</h2>
          </v-card-title>
          <v-card-text class="pa-0" :class="{'pt-0 pb-2':$vuetify.breakpoint.smAndUp}">
            <v-form ref="createForm">
              <v-layout row wrap>
                <v-flex xs12>
                  <meny v-model="updateItem.mena_id" @changed="(e) => { updateItem.mena = e; }" :disabled="editMode"></meny>
                </v-flex>
              </v-layout>
              <h3 class="mt-3">Když:</h3>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Výše první smlouvy"
                    class="mx-2"
                    :suffix="updateItem.mena != null ? updateItem.mena.zkratka : ''"
                    type="number"
                    v-model="updateItem.vyse_prvni_smlouvy"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-text-field
                    label="Výše druhé smlouvy"
                    class="mx-2"
                    :suffix="updateItem.mena != null ? updateItem.mena.zkratka : ''"
                    type="number"
                    v-model="updateItem.vyse_druhe_smlouvy"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <h3 class="mt-3">tak:</h3>
              <v-layout>
                <v-flex xs12>
                  <v-text-field
                    label="Maximální sleva"
                    class="mx-2"
                    :suffix="updateItem.mena != null ? updateItem.mena.zkratka : ''"
                    type="number"
                    v-model="updateItem.maximalni_sleva"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create" :loading="sending" v-if="!editMode"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
            <v-btn color="blue darken-3 elevation-0" dark @click="edit" :loading="sending" v-else><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" v-if="!sending" @click="dialogCreate=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogRemove"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogRemove"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Smazání slevy</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            Opravu chcete smazat slevu na poplatek spoření v max. výši {{removeItem.maximalni_sleva | formatMoney}} Kč?
          </v-card-text>
          <v-divider class="mt-2 mb-2"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red elevation-0" dark @click="remove" :loading="removing"><v-icon class="mr-2">delete</v-icon>Smazat</v-btn>
            <v-btn color="grey elevation-0 lighten-3" @click="dialogRemove=false" v-if="!removing">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm6>
                <h3>Pravidla slev z&nbsp;poplatku spoření</h3>
              </v-flex>
              <v-flex xs12 sm6 class="text-xs-left text-sm-right">
                <v-btn color="blue darken-3" class="ma-0 mb-3" :class="{'mt-3 v-btn--block': $vuetify.breakpoint.xs}" outline @click="createClick">
                  <v-icon class="mr-2">add</v-icon>
                  Nová sleva
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.mena.nazev }}</td>
                  <td>{{ props.item.vyse_prvni_smlouvy | formatMoney }} {{ props.item.mena.zkratka }}</td>
                  <td>{{ props.item.vyse_druhe_smlouvy | formatMoney }} {{ props.item.mena.zkratka }}</td>
                  <td>{{ props.item.maximalni_sleva | formatMoney }} {{ props.item.mena.zkratka }}</td>
                  <td class="text-xs-right">
                    <v-btn color="primary" class="elevation-0 ma-0" @click="editClick(props.item)">
                      <v-icon small class="mr-2">edit</v-icon> Upravit
                    </v-btn>
                    <v-btn color="red" class="elevation-0 ma-0" @click="removeClick(props.item)" flat>
                      <v-icon small class="mr-2">delete</v-icon> Smazat
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      dialog: false,
      editMode: false,
      dialogDetail: false,
      loading: false,
      sending: false,
      dialogCreate: false,
      headers: [
        { text: 'Měna', value: 'mena', sortable: false },
        { text: 'První smlouva', value: 'prvni_smlouva', sortable: false },
        { text: 'Druhá smlouva', value: 'druha_smlouva', sortable: false },
        { text: 'Maximální sleva', value: 'maximalni_sleva', sortable: false },
        { text: '', value: null, sortable: false, align: "center" }
      ],
      items: [],
      updateItem: null,
      dialogInit: { vyse_prvni_smlouvy: null, vyse_druhe_smlouvy: null, maximalni_sleva: null, mena_id: null, mena: null },
      sending: false,
      valid: true,
      dialogRemove: false,
      removing: false,
      removeItem: null
    }
  },
  mounted () {
    this.load();
  },
  methods: {
    load (f) {
      window.API.get("produkty/slevy-poplatek-sporeni").then(function(body) {
        this.items = body;
        if (typeof f == "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.updateItem = window.th.copy(this.dialogInit);
      this.editMode = false;
      this.dialogCreate = true;
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.post("produkty/slevy-poplatek-sporeni", this.updateItem).then(function(body) {
          if (body.inserted) {
            this.load(() => {
              this.dialogCreate = false;
              this.sending = false;
            });
          }
          else
            this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    },
    editClick (v) {
      this.updateItem = window.th.copy(v);
      this.editMode = true;
      this.dialogCreate = true;
    },
    edit () {
      this.sending = true;
      window.API.put("produkty/slevy-poplatek-sporeni/" + this.updateItem.id, this.updateItem).then(function(body) {
        if (body.updated) {
          this.load(() => {
            this.dialogCreate = false;
            this.sending = false;
          });
        }
        else
          this.sending = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.sending = false;
      }.bind(this));
    },
    removeClick(v) {
      this.removeItem = v;
      this.dialogRemove = true;
    },
    remove () {
      this.removing = true;
      window.API.delete("produkty/slevy-poplatek-sporeni/" + this.removeItem.id).then(function(body) {
        if (body.deleted) {
          this.load(() => {
            this.dialogRemove = false;
            this.removing = false;
          });
        }
        else
          this.removing = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.removing = false;
      }.bind(this));
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Slevy/SlevyPoplatkySporeni.vue